import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormikErrors, FormikTouched } from "formik";

interface LabelInsideDateInputProps {
  label: string;
  id: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  error?:
    | string
    | string[]
    | FormikErrors<any>
    | FormikErrors<any>[]
    | undefined;
  width?: string;
  showLabel?: boolean;
}

const LabelInsideDateInputField: React.FC<LabelInsideDateInputProps> = ({
  label,
  id,
  value,
  onChange,
  onBlur,
  error,
  width = "w-100",
  touched,
  showLabel = true,
}) => {
  return (
    <div className={width}>
      {label !== null ? (
        <>
          <label htmlFor="">{label}</label>
        </>
      ) : null}
      <div
        className={error ? "label-inside-input-error input-container-wrapper" : "label-inside-input input-container-wrapper"}
      >
        <DatePicker
          id={id}
          name={id}
          selected={value}
          onChange={onChange}
          onBlur={onBlur}
          dateFormat="dd/MM/yyyy"
          className="input-control"
        />
        {touched && error && (
          <div className="error-line">
            <span>{error as string}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LabelInsideDateInputField;
